<div class="professional-container">
  <form [formGroup]="professionalForm" class="professional-group">
    <div class="professional-title-and-closed">
      <p class="title">{{ titleModal }}</p>
      <button class="btn btn-close" (click)="closeActionModal()">
        <img src="../../../../assets/svgs/close_btn.svg" alt="Fechar">
      </button>
    </div>

    <div class="input-control">
      <app-select
        labelText="Tipo de negócio"
        height="110"
        [textTitle]="professionalForm.get('type').value ? professionalForm.get('type').value : ''"
        field="name"
        sizeList="5"
        [disabled]="!listType.length"
        [listItems]="listType"
        (sendSearch)="professionalForm.get('type').setValue($event.name)"
        (clearDropDown)="professionalForm.get('type').setValue(null)">
      </app-select>
    </div>

    <div class="input-control">
      <app-input id="pfn-name" [label]="'Nome completo *'"
        formControlName="name" [messageError]="'Nome requerido'"
        [error]="professionalForm.get('name').invalid" [placeholder]="''">
      </app-input>
    </div>

    <div class="input-control control">
      <app-select
        labelText="Tipo de negócio"
        height="150"
        field="name"
        [textTitle]="professionalForm.get('enterprise').value ? professionalForm.get('enterprise').value : ''"
        sizeList="5"
        [disabled]="!listEnterprise.length"
        [listItems]="listEnterprise"
        (sendSearch)="professionalForm.get('enterprise').setValue($event.name)"
        (clearDropDown)="professionalForm.get('enterprise').setValue(null)">
      </app-select>
    </div>
    <div class="button-container">
      <button class="btn btn-cancel" (click)="closeActionModal()">Cancelar</button>
      <button class="btn btn-continue" (click)="sendItem()">Adicionar</button>
    </div>
  </form>
</div>